import Image from 'next/image';
import Link from 'next/link';

import { Grid, Avatar, Typography, Divider, CardActionArea } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { RichText } from 'prismic-reactjs';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

import { CardProduct } from '@/src/components/organisms';

const useStyles = makeStyles(theme => ({
  cardProduct: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderRadius: theme.spacing(1),
    '& .card-product__content': {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  image: {
    borderRadius: theme.spacing(0, 0, 20, 0),
  },
  blogContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  list: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  avatarContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatar: {
    marginRight: theme.spacing(1),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  button: {
    minWidth: '100%',
    maxWidth: '100%',
    [theme.breakpoints.up('sm')]: {
      minWidth: 420,
    },
  },
  answerCount: {
    padding: theme.spacing(1 / 2, 1),
    borderRadius: theme.spacing(1),
    background: theme.palette.secondary.light,
    color: 'white',
    fontWeight: 300,
  },
}));

function CardBlog({ href, title, description, cover, date, author }) {
  const classes = useStyles();

  return (
    <Grid item xs={12} md={4} data-aos="fade-up">
      <Link href={href} passHref>
        <CardActionArea component="a">
          <CardProduct
            withShadow
            liftUp
            className={classes.cardProduct}
            mediaContent={
              <Image
                src={cover?.url || '/images/blog-post-cover-placeholder.png'}
                alt={cover?.alt || RichText.asText(title)}
                layout="fill"
                objectFit="cover"
                className={classes.image}
              />
            }
            cardContent={
              <div className={classes.blogContent}>
                <Typography variant="h6" component="div" color="textPrimary" gutterBottom>
                  {RichText.asText(title)}
                </Typography>
                <Typography variant="body1" color="textSecondary">
                  {description}
                </Typography>
                <div style={{ flexGrow: 1 }} />
                <Divider className={classes.divider} />
                <div className={classes.list}>
                  <div className={classes.avatarContainer}>
                    <Avatar
                      src={author?.avatar?.url}
                      alt={author?.name}
                      className={classes.avatar}
                    />
                    <Typography variant="body2" color="textPrimary">
                      {author?.name}
                    </Typography>
                  </div>
                  <Typography variant="overline" color="textSecondary">
                    <FormattedDate value={date} />
                  </Typography>
                </div>
              </div>
            }
          />
        </CardActionArea>
      </Link>
    </Grid>
  );
}

CardBlog.propTypes = {
  href: PropTypes.string,
  title: PropTypes.any,
  description: PropTypes.any,
  cover: PropTypes.object,
  date: PropTypes.string,
  author: PropTypes.object,
};

export default CardBlog;
